import { useCallback, useState } from 'react'
import { Button, Input, LoadingIndicator } from '@/shared/ui'
import { useCreateInviteLinksGroupSitesMutation } from '@/shared/api/invite-links-group/invite-links-group.sites.mutations'
import { InviteSVGIcon, PlusSVGIcon } from '@/shared/assets'
import { useCreateGroupValidation } from '../hooks/useCreateGroupValidation'
import clsx from 'clsx'
import { useActiveWorkspace } from '@/true-fsd/data/advertiser-account/hooks'

export type CreateGroupSitesProps = {
    siteId: number
}
export const CreateGroupSites = ({ siteId }: CreateGroupSitesProps) => {
    const { subscription } = useActiveWorkspace()

    const { isValid, errors, validate } = useCreateGroupValidation()

    const createGroup = useCreateInviteLinksGroupSitesMutation()

    const [groupName, setGroupName] = useState<string>('')

    const handleNameChange = (value: string) => {
        setGroupName(value)
    }

    const [isCreating, setIsCreating] = useState(false)
    const createGroupHandler = useCallback(async () => {
        const generateLinkData = { groupName }

        const isValidData = validate(generateLinkData)

        if (!isValidData) {
            return
        }

        try {
            setIsCreating(true)

            createGroup.mutate(
                {
                    groupName,
                    siteId: siteId,
                    siteLinkIds: [],
                },
                {
                    onSettled: () => {
                        setIsCreating(false)
                    },
                }
            )
        } catch (error) {
            console.error('Failed to create group:', error)
        }

        setGroupName('')
    }, [groupName, validate, createGroup, siteId])

    const forbidToCreateGroups = subscription.status === 'expired'

    return (
        <div className="create-group">
            <div className="create-group__icon">
                <InviteSVGIcon />
            </div>
            <Input
                placeholder="Введите название группы"
                value={groupName}
                onChange={handleNameChange}
                error={Boolean(errors.groupName)}
                className="create-group__input"
            />
            <Button
                onClick={createGroupHandler}
                disabled={!isValid}
                disabledBySubscriptionStatus={forbidToCreateGroups}
                className={clsx(`create-group__button`, {
                    'create-group__button--disabled':
                        !isValid || forbidToCreateGroups,
                })}
                wrapperClassName="create-group__button-container"
                tooltipText="Чтобы создавать новые ссылки, оплатите подписку на сервис"
            >
                {isCreating ? (
                    <LoadingIndicator
                        style={{
                            width: '20px',
                            height: '20px',
                            marginRight: '0.5em',
                        }}
                    />
                ) : (
                    <PlusSVGIcon
                        className={clsx(`button__icon-left`, {
                            'button__icon--disabled':
                                !isValid || forbidToCreateGroups,
                        })}
                    />
                )}
                Создать группу
            </Button>
        </div>
    )
}
